/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2020
 */


import DelayedAnalyticsManager from "@/core/analytic/DelayedAnalyticsManager";

let analyticManager = new DelayedAnalyticsManager()

console.log("analyticManager = ", analyticManager)

export default analyticManager




